<footer class="flow-footnote">
  <!-- reskin P1: this row IS the design's `.trust` strip —
       "Insured by A-Rated Carriers · SOC 2 Certified · Powered by Get Covered".
       The reference renders it per-view inside <main>; app-wide here so every
       flow (not just PMA) gets it, and so the compliance links below stay
       attached to it. -->
  <!-- Assurance line only. The "SOC 2 Certified" mark and the "Powered by Get
       Covered" block were both removed here on request. The separator dots went
       with them: they existed solely to divide the three items, and a single
       item needs none.

       `powered-by-gc` is NOT gone from the app — it still renders inside the
       panel on each PMA flow screen, which is where it belongs. This removes the
       second, app-wide copy in the footer. -->
  <div class="flow-footnote__row flow-footnote__row--assurance">
    <span class="flow-footnote__assurance">{{ 'footer.insured_by_a_rated_carriers' | translate }}</span>
  </div>

  <nav class="flow-footnote__row flow-footnote__row--legal" aria-label="Legal">
    <!-- One privacy link for every portal: Get Covered's own notice. The
         renters/assurant flows used to swap in Assurant's carrier document
         here (/assurant/legal-content/PrivacyPolicy, served by the V3
         content_management API); that variant was dropped on request so the
         footer always points at the notice we publish at
         getcovered.io/privacy. Assurant's notice is still the privacy policy
         inside the checkout terms modal, which is where it applies to the
         policy being bound. -->
    <a routerLink="privacy-policy">{{ 'menu.privacy_policy' | translate }}</a>
    <a routerLink="Terms-of-Use">{{ 'menu.terms_of_use' | translate }}</a>
    <a routerLink="licenses">{{ 'menu.licenses' | translate }}</a>
  </nav>

  <div *ngIf="footerCopyrightHtml$ | async as copyrightHtml"
       class="flow-footnote__copyright"
       [innerHTML]="copyrightHtml"></div>
</footer>
